import { useCallback } from 'react';
import { registerMutation, useMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import Raven from 'raven-js';
const SAVE_USER_CUSTOMIZATION = registerMutation({
  fieldName: 'saveUserCustomization',
  args: ['cardId', 'objectTypeId', 'cardType', 'configuration'],
  fetcher({
    cardId,
    objectTypeId,
    cardType,
    configuration
  }) {
    return http.post(`/crm-record-cards/v3/crm-cards/user-level-customization/${encodeURIComponent(cardId)}`, {
      query: {
        objectTypeId,
        cardType
      },
      data: {
        cardType,
        configuration
      }
    });
  }
});
export function useUserCustomization({
  cardId,
  objectTypeId
}) {
  const [saveUserCustomization] = useMutation(SAVE_USER_CUSTOMIZATION);
  const updateSortConfiguration = useCallback(sortConfiguration => {
    return saveUserCustomization({
      variables: {
        cardId,
        objectTypeId,
        cardType: 'ASSOCIATION_V3',
        configuration: {
          sortConfiguration
        }
      }
    }).catch(error => {
      Raven.captureException(error, {
        extra: {
          context: 'sort_configuration_save',
          cardId,
          objectTypeId
        }
      });
      throw error;
    });
  }, [cardId, objectTypeId, saveUserCustomization]);
  return {
    updateSortConfiguration
  };
}